const imageExtensions = ['.jpg', '.jpe', '.jpeg', '.png'];

export class Fact {
  static isImage(fact) {
    // return fact['agent_attachedfile.data'];
    if (!fact) {
      return false;
    }
    let fileName = fact['agent_attachedfile.data'];
    if (!fileName || !imageExtensions.some(ext => fileName.endsWith(ext))) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/common/fact.js